import { usePaymentPage } from "Payments/PaymentPage/PaymentPageContext";

import { usePaymentForm } from "../PaymentFormContext";

export function useSetAmountToComplete() {
  const { state } = usePaymentPage();
  const {
    state: { formStages },
    dispatch,
  } = usePaymentForm();
  const isFullyLoggedIn = state.user?.loginLevel === "full";
  const { selectedPaymentMethodID } = state;
  const { isACHAllowed } = state.network;

  return function () {
    dispatch({
      type: "setFormStage",
      stage: "amount",
      value: "complete",
    });

    // if the user is not fully logged in, their next step is to request an auth code.
    // if they are fully logged in, no update is needed.
    if (isFullyLoggedIn) {
      // user is fully logged in... set that flag, and set the proper paymentInfo flag
      dispatch({
        type: "setFormStage",
        stage: "auth",
        value: "isFullyLoggedIn",
      });

      const paymentInfoValue = selectedPaymentMethodID
        ? "methodSelected"
        : formStages.paymentInfo === "addCard" // This can occur when user fills out card then changes amount. Without this, it closes the card and loses entered card info
        ? "addCard"
        : isACHAllowed
        ? "chooseAddMethodType"
        : "addCard";

      dispatch({
        type: "setFormStage",
        stage: "paymentInfo",
        value: paymentInfoValue,
      });
    } else if (formStages.auth === "untouched") {
      dispatch({
        type: "setFormStage",
        stage: "auth",
        value: "requestCode",
      });
    } else {
      // don't do anything.
      // for instance... they started auth (or skipped auth) and then went back to edit the amount
    }
  };
}
